/**
 * Dessin d'un chariot (petit / moyen / grand à 2 étages) : sa lettre dans une
 * pastille au-dessus, et le nombre de colis au centre de chaque emplacement.
 * Un clic sur un étage le sélectionne.
 * emplacements : [{ id, etage, colis?: [], nb? }] ; compteurs=false : sans nombres.
 */
const DIM = {
  petit: { w: 120, h: 62 },
  moyen: { w: 120, h: 104 },
  grand: { w: 150, h: 150 },
};

export function ChariotVisuel({ type, lettre, emplacements = [], selection = null, actif = null, surligne = [], onSelect, taille = 1, compteurs = true, testId }) {
  const d = DIM[type] || DIM.petit;
  const W = d.w + 20;
  const x0 = 10;
  const y0 = lettre ? 34 : 6;
  const H = y0 + d.h + 26;
  const nb = (e) => (e?.nb ?? e?.colis?.length ?? 0);
  const etages = type === "grand"
    ? [{ e: emplacements.find((x) => x.etage === "haut"), y: y0, h: d.h / 2, label: "haut" }, { e: emplacements.find((x) => x.etage === "bas"), y: y0 + d.h / 2, h: d.h / 2, label: "bas" }]
    : [{ e: emplacements[0], y: y0, h: d.h, label: null }];

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width={W * taille} height={H * taille} className="overflow-visible select-none" data-testid={testId} role="img" aria-label={lettre ? `Chariot ${lettre}` : "Chariot"}>
      {lettre && (
        <g>
          <circle cx={W / 2} cy={16} r={15} fill="hsl(var(--primary))" />
          <text x={W / 2} y={22} fontSize="17" fontWeight="800" textAnchor="middle" fill="hsl(var(--primary-foreground))">{lettre}</text>
          <line x1={W / 2} y1={31} x2={W / 2} y2={y0} stroke="currentColor" strokeWidth="1.5" opacity="0.5" />
        </g>
      )}
      {etages.map(({ e, y, h, label }) => {
        const n = nb(e);
        const sel = e && selection === e.id;
        const enCours = e && actif === e.id;
        const hl = e && surligne.includes(e.id);
        const fill = hl ? "rgba(239,68,68,0.25)" : enCours ? "rgba(16,185,129,0.25)" : sel ? "hsl(var(--primary) / 0.25)" : compteurs && n ? "hsl(var(--primary) / 0.10)" : "transparent";
        const stroke = hl ? "#ef4444" : enCours ? "#10b981" : sel ? "hsl(var(--primary))" : "currentColor";
        return (
          <g key={label || "u"} className={onSelect && e ? "cursor-pointer" : ""} onClick={() => e && onSelect?.(e)} data-testid={e && lettre ? `etage-${lettre}-${label || "u"}` : undefined}>
            <rect x={x0} y={y} width={d.w} height={h} fill={fill} stroke={stroke} strokeWidth={sel || enCours || hl ? 3 : 2} rx={2} />
            {label && <text x={x0 + 6} y={y + 13} fontSize="10" fill="currentColor" opacity="0.65">{label}</text>}
            {compteurs && e && (
              <>
                <text x={x0 + d.w / 2} y={y + h / 2 + 6} fontSize={h < 70 ? 20 : 26} fontWeight="800" textAnchor="middle" fill="currentColor">{n}</text>
                <text x={x0 + d.w / 2} y={y + h / 2 + (h < 70 ? 20 : 24)} fontSize="10" textAnchor="middle" fill="currentColor" opacity="0.65">colis</text>
              </>
            )}
          </g>
        );
      })}
      {/* roues */}
      <line x1={x0} y1={y0 + d.h + 2} x2={x0 + d.w} y2={y0 + d.h + 2} stroke="currentColor" strokeWidth="2" />
      {[x0 + 14, x0 + d.w - 14].map((cx) => (
        <ellipse key={cx} cx={cx} cy={y0 + d.h + 12} rx="11" ry="8" fill="none" stroke="currentColor" strokeWidth="2" />
      ))}
    </svg>
  );
}
